// CountDown.jsx — Pure UI. Counts down from 5, fires callback when done.

import React, { useEffect, useRef, useState } from 'react';

const CountDown = ({ onComplete }) => {
    const [seconds, setSeconds] = useState(5);
    const intervalRef = useRef(null);
    const onCompleteRef = useRef(onComplete);
    onCompleteRef.current = onComplete;

    useEffect(() => {
        setSeconds(5);
        intervalRef.current = setInterval(() => {
            setSeconds(prev => {
                if (prev <= 1) {
                    onCompleteRef.current && onCompleteRef.current();
                    return 5;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(intervalRef.current);
    }, []);

    return (
        <span className="z-index-1 color-red-2 count-down-text">
            <strong>{seconds}</strong>
        </span>
    );
};

export default CountDown;
